import React from 'react'
import { businessIntro } from './content'
import type { Lang } from './types'

interface BusinessIntroV2Props {
  currentLang: Lang
}

/**
 * BusinessIntroV2
 * Square image (left) + brand narrative (right) — "Brewing Connections" block.
 * Cream paper background, generous whitespace, serif headlines.
 */
const BusinessIntroV2: React.FC<BusinessIntroV2Props> = ({ currentLang }) => {
  return (
    <section className="bg-[#FAF9F1] py-20 md:py-28">
      <div className="mx-auto max-w-[1600px] px-6 md:px-10">
        <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-2 md:gap-20">
          {/* Image */}
          <div className="relative aspect-square w-full overflow-hidden">
            <img
              src={businessIntro.image}
              alt={businessIntro.imageAlt[currentLang]}
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>

          {/* Copy */}
          <div className="md:pl-6">
            <p
              className="mb-6 text-[13px] tracking-[0.18em] text-black/70"
              style={{ fontFamily: "'Noto Serif TC', 'EB Garamond', serif", fontWeight: 300 }}
            >
              {businessIntro.eyebrow[currentLang]}
            </p>

            <h2
              className="mb-10 text-black"
              style={{
                fontFamily: "'EB Garamond', 'Noto Serif TC', serif",
                fontWeight: 400,
                fontSize: 'clamp(1.875rem, 3.2vw, 2.5rem)',
                letterSpacing: '0.04em',
                lineHeight: 1.25,
              }}
            >
              {businessIntro.headline[currentLang]}
            </h2>

            <p
              className="text-[15px] leading-loose text-black/75"
              style={{
                fontFamily: "'Noto Serif TC', 'Noto Sans TC', sans-serif",
                fontWeight: 300,
                letterSpacing: '0.03em',
              }}
            >
              {businessIntro.body[currentLang]}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}

export default BusinessIntroV2
